import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CreateVendorPayload, UpdateVendorPayload, VendorResponse } from './model'
import { of } from 'rxjs'
import { concatMap, toArray } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class VendorsService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<VendorResponse[]>(`@api/vendor/all/`)
  }

  add(payload: CreateVendorPayload) {
    return this.http.post<VendorResponse>(`@api/vendor/`, payload)
  }

  update(id: string, payload: UpdateVendorPayload) {
    return this.http.put<VendorResponse>(`@api/vendor/${id}`, payload)
  }

  updateVendors(items: { id: string; payload: UpdateVendorPayload }[]) {
    return of(...items).pipe(
      concatMap(({ id, payload }) => this.update(id, payload)),
      toArray()
    )
  }

  get(id: string) {
    return this.http.get<VendorResponse>(`@api/vendor/${id}`)
  }

  delete(id: string) {
    return this.http.delete(`@api/vendor/delete/${id}`)
  }

  deleteVendors(ids: string[]) {
    return of(...ids).pipe(
      concatMap((id) => this.delete(id)),
      toArray()
    )
  }
}
